import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { boardViewsService } from '../api/board-views.service';
import { BOARD_KEYS } from './queryKeys';

export function useBoardViews(boardId: string) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId) ?? '';

  const { data, isLoading, isError } = useQuery({
    queryKey: BOARD_KEYS.views(activeOrganizationId, boardId),
    queryFn: ({ signal }) => boardViewsService.getByBoard(boardId, signal).then((r) => r.data),
    staleTime: 300_000,
    enabled: !!activeOrganizationId && !!boardId,
  });

  return {
    views: data ?? [],
    isLoading,
    isError,
  };
}
